// src/App.js

import React, { useState, useEffect, useRef } from 'react';
import cami from './images/chat.png';


const App = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  
  const messagesEndRef = useRef(null);

  const camiImageUrl = 'https://placehold.co/128x128/60a5fa/ffffff?text=Cami';

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(scrollToBottom, [messages]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    const userMessage = currentMessage.trim();
    if (!userMessage) return;

    const API_URL = process.env.REACT_APP_API_URL;
    if (!API_URL) {
      console.error("API URL no definida");
      return;
    }

    const updatedMessages = [
      ...messages,
      { text: userMessage, sender: "me" }
    ];

    setMessages(updatedMessages);
    setCurrentMessage("");
    setIsLoading(true);

    setMessages(prev => [
      ...updatedMessages,
      { text: "...", sender: "bot", id: "loading" }
    ]);

    try {
      const limited = updatedMessages.slice(-15);

      const formattedMessages = limited.map(msg => ({
        role: msg.sender === "me" ? "user" : "model",
        content: msg.text
      }));

      const response = await fetch(`${API_URL}/api/chat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ messages: formattedMessages })
      });

      const data = await response.json();

      setMessages(prev => {
        const filtered = prev.filter(msg => msg.id !== "loading");
        return [
          ...filtered,
          { text: data.reply, sender: "bot" }
        ];
      });

    } catch (error) {
      setMessages(prev => {
        const filtered = prev.filter(msg => msg.id !== "loading");
        return [
          ...filtered,
          {
            text: "Lo siento, hubo un error al conectar con el servidor.",
            sender: "bot"
          }
        ];
      });
    }

    setIsLoading(false);
  };

  const summarizeChat = async () => {
    if (messages.length === 0) {
      const noMessagesBotMessage = {
        text: "No hay mensajes para resumir. Inicia una conversación primero.",
        sender: "bot",
        id: Date.now()
      };
      setMessages(prevMessages => [...prevMessages, noMessagesBotMessage]);
      return;
    }
    
    const botMessage = {
      text: "La función de resumen se ha movido al backend y aún no está implementada en el frontend. ¡Pronto estará disponible!",
      sender: "bot",
      id: Date.now()
    };
    setMessages(prevMessages => [...prevMessages, botMessage]);
  };
  
  const startNewChat = () => {
    setMessages([]);
    console.log("Iniciando un nuevo chat...");
  };

  return (
    <div className="font-sans antialiased text-gray-900 bg-gray-100">
      <style>
        {`
        @keyframes bounce {
          0%, 100% {
            transform: translateY(-25%);
            animation-timing-function: cubic-bezier(0.8,0,1,1);
          }
          50% {
            transform: none;
            animation-timing-function: cubic-bezier(0,0,0.2,1);
          }
        }
        .animate-bounce {
          animation: bounce 1s infinite;
        }

        @keyframes scale-up {
          from {
            transform: scale(0.5);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
        .animate-scale-up {
          animation: scale-up 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        `}
      </style>

      {/* Botón flotante para abrir el chat */}
      <div id="chatbot" className="fixed bottom-4 right-4 z-50">
        {!isOpen ? (
          <div className="relative cursor-pointer" onClick={() => {
            setIsOpen(true);
            startNewChat();
          }}>
            {/* Contenedor del icono con animación y sombra */}
            <div className="bg-white p-2 rounded-full shadow-lg animate-bounce">
              <img 
                src={cami}
                className="w-16 h-16 rounded-full" 
                alt="Cami chatbot" 
              />
            </div>
            {/* Texto "¡Hola! Soy Cami" */}
            <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-white text-gray-700 p-2 rounded-lg shadow-lg text-sm whitespace-nowrap">
              ¡Hola! Soy Cami
            </div>
          </div>
        ) : (
          /* Ventana del chat (pop-up) */
          <div className="bg-white pb-3 w-80 h-[500px] shadow-lg rounded-lg flex flex-col animate-scale-up">
            {/* Cabecera del chat */}
            <div className="flex justify-between items-center mb-4 bg-indigo-500 p-1 rounded-t-lg">
              <div className="flex items-center p-1">
                <img 
                  src={cami}
                  className="w-8 h-8 mr-2 rounded-full" 
                />
                <h3 className="text-lg font-bold text-white">Chat con Cami ✨</h3>
              </div>
              <button 
                onClick={() => {
                  setIsOpen(false);
                  setMessages([]);
                }} 
                className="text-white text-2xl pr-3"
              >
                ×
              </button>
            </div>

            {/* Botón para la nueva funcionalidad de resumen */}
            {/* <button
              onClick={summarizeChat}
              className={`bg-indigo-500 text-white px-4 py-2 mb-2 rounded-lg text-sm font-semibold transition-colors
                          ${isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-indigo-600'}`}
              disabled={isLoading}
            >
              Resumir chat ✨
            </button> */}

            {/* Área de mensajes */}
            <div className="flex-1 px-3 overflow-y-auto mb-4 space-y-2">
              {messages.map((msg, index) => {
                if (!msg || typeof msg.text !== 'string') return null;
                
                return (
                  <div key={index} className={`flex ${msg.sender === 'bot' ? 'justify-start' : 'justify-end'}`}>
                    <div className={`max-w-xs px-4 py-2 rounded-lg ${
                      msg.sender === 'bot' ? 'bg-purple-100 text-gray-900' : 
                      'bg-pink-500 text-white'
                    }`}>
                      {(msg.text || '').split('\n').map((line, i) => (
                        <p key={i}>{line}</p>
                      ))}
                    </div>
                  </div>
                );
              })}
              <div ref={messagesEndRef} />
            </div>

            <form className="flex px-4" onSubmit={handleSendMessage}>
              <input
                type="text"
                value={currentMessage}
                onChange={(e) => setCurrentMessage(e.target.value)}
                placeholder="Escribe tu mensaje..."
                className="flex-grow px-3 py-2 mr-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-500"
                disabled={isLoading}
              />
              <button
                className={`text-white font-bold px-3 py-2 rounded-xl transition-colors ${
                  currentMessage.trim() ? 'bg-indigo-600' : 'bg-indigo-300'
                } ${isLoading ? 'opacity-50 ' : ''}`}
                disabled={isLoading}
              >
                Enviar
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
